import { Box, Button } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useStartReviewMutation } from '../generated/graphql'
import { ConfirmDialog } from './ConfirmDialog'

interface StartReviewButtonProps {
  selectedPaymentIds: number[]
  count: number
  onSuccess: () => void
}
export function StartReviewButton({ selectedPaymentIds, count, onSuccess }: StartReviewButtonProps) {
  const { enqueueSnackbar } = useSnackbar()
  const [confirmOpen, setConfirmOpen] = useState(false)
  const startReviewMutation = useStartReviewMutation({
    onSuccess: () => {
      enqueueSnackbar('Review started successfully', { variant: 'success' })
      onSuccess()
    },
    onError: (error: Error) => {
      console.error(error)
      enqueueSnackbar(error?.message || 'Failed to start review', {
        variant: 'error',
      })
    },
  })

  const handleStartReview = () =>
    startReviewMutation.mutate({
      paymentIds: selectedPaymentIds.length > 0 ? selectedPaymentIds : undefined,
    })

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        variant="contained"
        color="primary"
        disabled={startReviewMutation.isPending || !count}
        onClick={() => setConfirmOpen(true)}
      >
        Start Review of ({count}) OPEN Payments
      </Button>

      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        confirmLabel="Start Review"
        onConfirm={handleStartReview}
      >
        You are about to move {count} selected OPEN payment(s) into review.
      </ConfirmDialog>
    </Box>
  )
}
